import { render, staticRenderFns } from "./menu-meal-chart.vue?vue&type=template&id=ee204b7a&"
import script from "./menu-meal-chart.vue?vue&type=script&lang=js&"
export * from "./menu-meal-chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports